import{useLocaleContext}from"../../modules/useLocale";export default useLocaleContext;